module.exports = __webpack_public_path__ + "static/sphere_coldplunge_bg-fa411b3a4b2a37dcf46db31763fa71ed.png";